import script from "./BuyForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyForm.vue?vue&type=script&setup=true&lang=ts"

import "./BuyForm.vue?vue&type=style&index=0&id=bb790472&lang=scss&scoped=true"
import "./BuyForm.vue?vue&type=style&index=1&id=bb790472&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb790472"]])

export default __exports__